import React from 'react';
import { WebsiteDesignProps } from './types';
import { GraduationCap, BookOpen, Users } from 'lucide-react';
import { Button } from "@/components/ui/button";

const UniversityModern: React.FC<WebsiteDesignProps> = ({ previewData }) => {
    const schoolName = previewData?.name || "State University";

    return (
        <div className="bg-white min-h-screen font-sans">
            <div className="bg-[#cc0000] text-white py-2 px-6 text-sm font-bold flex justify-between">
                <span>Accepting Applications for Fall 2026</span>
                <div className="flex gap-4">
                    <a href="#" className="hover:underline">Alumni</a>
                    <a href="#" className="hover:underline">Staff</a>
                    <a href="#" className="hover:underline">Parents</a>
                </div>
            </div>

            <nav className="border-b border-gray-200 py-6 px-6 sticky top-0 bg-white z-50">
                <div className="container mx-auto flex justify-between items-center">
                    <div className="text-3xl font-serif font-black tracking-tighter text-[#1a1a1a]">
                        {schoolName}
                    </div>
                    <div className="hidden lg:flex gap-8 font-bold text-gray-700 uppercase text-sm tracking-wide">
                        <a href="#" className="hover:text-[#cc0000]">Admissions</a>
                        <a href="#" className="hover:text-[#cc0000]">Academics</a>
                        <a href="#" className="hover:text-[#cc0000]">Research</a>
                        <a href="#" className="hover:text-[#cc0000]">Campus Life</a>
                        <a href="#" className="hover:text-[#cc0000]">Athletics</a>
                    </div>
                    <Button variant="ghost" className="text-[#cc0000] font-bold hover:bg-[#cc0000]/10">
                        <span className="hidden sm:inline">Portal Login</span>
                    </Button>
                </div>
            </nav>

            <header className="relative h-[600px] flex items-center">
                <div className="absolute inset-0 z-0">
                    <img src="https://images.unsplash.com/photo-1523050854058-8df90110c9f1?q=80&w=2070&auto=format&fit=crop" className="w-full h-full object-cover" alt="Campus" />
                    <div className="absolute inset-0 bg-gradient-to-r from-[#1a1a1a]/90 via-[#1a1a1a]/40 to-transparent"></div>
                </div>
                
                <div className="container mx-auto px-6 relative z-10">
                    <div className="max-w-2xl text-white">
                        <div className="w-16 h-2 bg-[#cc0000] mb-6"></div>
                        <h1 className="text-5xl md:text-7xl font-bold mb-6 leading-tight">
                            Ignite Your <br/> Potential.
                        </h1>
                        <p className="text-xl text-gray-200 mb-8 font-light leading-relaxed">
                            A world-class research institution committed to addressing the great challenges of our time through education, innovation, and leadership.
                        </p>
                        <div className="flex gap-4">
                            <Button className="bg-[#cc0000] hover:bg-[#990000] text-white font-bold h-14 px-8 rounded-none uppercase tracking-wider text-sm">
                                Find Your Program
                            </Button>
                            <Button variant="outline" className="border-white text-white hover:bg-white hover:text-[#1a1a1a] font-bold h-14 px-8 rounded-none uppercase tracking-wider text-sm">
                                Visit Campus
                            </Button>
                        </div>
                    </div>
                </div>
            </header>

            <section className="bg-[#f4f4f4] py-20 border-b border-gray-200">
                <div className="container mx-auto px-6 grid grid-cols-1 md:grid-cols-3 gap-12 text-center md:text-left">
                    <div className="flex flex-col gap-4">
                        <GraduationCap className="w-12 h-12 text-[#cc0000]" />
                        <h3 className="text-2xl font-bold text-[#1a1a1a]">Undergraduate</h3>
                        <p className="text-gray-600 leading-relaxed">Choose from over 120 majors and minors designed to prepare you for a rapidly changing world.</p>
                        <a href="#" className="font-bold text-[#cc0000] hover:underline mt-2">Learn More &rarr;</a>
                    </div>
                    <div className="flex flex-col gap-4">
                        <BookOpen className="w-12 h-12 text-[#cc0000]" />
                        <h3 className="text-2xl font-bold text-[#1a1a1a]">Graduate & Professional</h3>
                        <p className="text-gray-600 leading-relaxed">Advanced degrees in business, law, medicine, and the arts for those seeking mastery.</p>
                        <a href="#" className="font-bold text-[#cc0000] hover:underline mt-2">Learn More &rarr;</a>
                    </div>
                    <div className="flex flex-col gap-4">
                        <Users className="w-12 h-12 text-[#cc0000]" />
                        <h3 className="text-2xl font-bold text-[#1a1a1a]">Continuing Education</h3>
                        <p className="text-gray-600 leading-relaxed">Flexible courses and certificates for lifelong learners and working professionals.</p>
                        <a href="#" className="font-bold text-[#cc0000] hover:underline mt-2">Learn More &rarr;</a>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default UniversityModern;
